import { shape, string, arrayOf, number } from 'prop-types'

export default {
  alt: string,
  src: string,
  srcSet: arrayOf(shape({ width: number.isRequired, src: string.isRequired })),
  sizes: arrayOf(string)
}
